function toggleProductGrid(lines) {
  const productGrid = document.querySelector('.searchtap-temp .product-grid.product-grid--grid');
  if (!productGrid) return;

  let view = 'default';
  if (lines === 1) view = 'mobile-single';
  else if (lines === 3) view = 'mobile-triple';

  productGrid.setAttribute('product-grid-view', view);
  const gridButtons = document.querySelectorAll('.st-mobile-grid-view span');

  gridButtons.forEach(button => {
    const buttonColumns = Number(button.dataset.gridLayoutColumns);
    button.classList.toggle('active', buttonColumns === lines);
  });
}

document.addEventListener('DOMContentLoaded', () => {
    const gridButtons = document.querySelectorAll('.st-mobile-grid-view span');
    if (window.innerWidth <= 768) { 
        gridButtons.forEach(button => {
            const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
            if (buttonColumns === 2) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });
    }
});
function updateImageUsingSlideShow() {
    const components = document.querySelectorAll('.searchtap-temp slideshow-component');

    components.forEach(component => {
        const scroller = component.querySelector('slideshow-slides');
        const slides = component.querySelectorAll('slideshow-slide');

        if (!scroller || !slides.length) return;

        const nextBtn = component.querySelector('.slideshow-control--next');
        const prevBtn = component.querySelector('.slideshow-control--previous');

        const slideWidth = () => scroller.clientWidth;

        function getCurrentIndex() {
            return Math.round(scroller.scrollLeft / slideWidth());
        }

        function scrollToIndex(index) {
            const maxIndex = slides.length - 1;

            if (index < 0) index = 0;
            if (index > maxIndex) index = maxIndex;

            scroller.scrollTo({
                left: index * slideWidth(),
                behavior: 'smooth'
            });
        }
        if (nextBtn) {
            nextBtn.addEventListener('click', function (e) {
                e.preventDefault();
                const current = getCurrentIndex();
                scrollToIndex(current + 1);
            });
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', function (e) {
                e.preventDefault();
                const current = getCurrentIndex();
                scrollToIndex(current - 1);
            });
        }
    });
}
document.addEventListener('DOMContentLoaded', () => {
  // updateImageUsingSlideShow();

  const GRID = document.querySelector('.searchtap-temp .product-grid');
  const PAGINATION = document.getElementById('product-grid-Pagination');

  if (!GRID || !PAGINATION) return;

  const PAGE_SIZE = 36;
  const availableBuffer = [];
  const loadedPages = new Set();

  let isLoading = false;
  let allPagesLoaded = false;

  let nextPageUrl =
    PAGINATION.querySelector('[data-url]')?.dataset.url || null;

  async function fetchPage(url) {
    if (!url) return null;

    try {
      const res = await fetch(url, {
        cache: 'no-store'
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      const html = await res.text();

      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const items = Array.from(
        doc.querySelectorAll(
          '.searchtap-temp .product-grid > li'
        )
      );

      availableBuffer.push(...items);

      const newPagination = doc.querySelector(
        '#product-grid-Pagination'
      );

      if (newPagination) {
        PAGINATION.innerHTML = newPagination.innerHTML;
      }

      const nextLink = newPagination?.querySelector('[data-url]');

      return nextLink?.dataset?.url || null;
    } catch (error) {
      console.error('Fetch page error:', error);
      return null;
    }
  }

  function renderNextBatch() {
    const fragment = document.createDocumentFragment();

    let count = 0;

    while (
      availableBuffer.length &&
      count < PAGE_SIZE
    ) {
      fragment.appendChild(
        availableBuffer.shift()
      );
      count++;
    }

    if (count) {
      GRID.appendChild(fragment);

      if (
        typeof updateImageUsingSlideShow ===
        'function'
      ) {
        // updateImageUsingSlideShow();
      }
    }
  }

  async function loadMore() {
    if (
      isLoading ||
      allPagesLoaded ||
      !nextPageUrl ||
      loadedPages.has(nextPageUrl)
    ) {
      return;
    }

    isLoading = true;
    loadedPages.add(nextPageUrl);

    try {
      const currentUrl = nextPageUrl;

      nextPageUrl = await fetchPage(currentUrl);

      renderNextBatch();

      if (!nextPageUrl) {
        allPagesLoaded = true;
        observer.disconnect();
      }

      console.log({
        loadedPage: currentUrl,
        nextPageUrl,
        productsOnPage:
          document.querySelectorAll(
            '.searchtap-temp .product-grid > li'
          ).length
      });
    } catch (e) {
      console.error('Load error:', e);
    }

    isLoading = false;
  }

  const sentinel = document.createElement('div');
  sentinel.className = 'infinite-scroll-sentinel';
  sentinel.style.height = '1px';

  GRID.parentNode.appendChild(sentinel);

  const observer = new IntersectionObserver(
    (entries) => {
      if (
        entries[0].isIntersecting &&
        !isLoading
      ) {
        loadMore();
      }
    },
    {
      root: null,
      rootMargin: '1000px',
      threshold: 0
    }
  );

  observer.observe(sentinel);
});
// document.addEventListener('DOMContentLoaded', function () {
//     updateImageUsingSlideShow();
//     const target = document.querySelector('#product-grid-Pagination');
//     if (target) {
//         let isLoading = false;
//         window.observer1 = new IntersectionObserver((entries) => {
//             entries.forEach((entry) => {
//                 if (entry.isIntersecting && !isLoading) {
//                     const btn = document.querySelector('#product-grid-Pagination .btn-outline-primary');
//                     if (btn) {
//                         isLoading = true;
//                         btn.click();
//                     }
//                 }
//             });
//         });

//         window.observer1.observe(target);
//         window.onClickCollectionPagination = async (link, event) => {
//             event.preventDefault();

//             link.style.width = `${link.offsetWidth}px`;
//             link.style.height = `${link.offsetHeight}px`;
//             link.innerHTML = `
         
//                 <div class="st-results-loader">
//                     <div class="result-loading" style="text-align: center"></div>
//                 </div>
//             `;
//             const response = await fetch(link.getAttribute('href'));
//             const data = await response.text();
//             const parser = new DOMParser();
//             const newDocument = parser.parseFromString(data, 'text/html');
//             document
//                 .querySelector('.searchtap-temp .product-grid')
//                 .insertAdjacentHTML('beforeend', newDocument.querySelector('.searchtap-temp .product-grid').innerHTML);

//             document
//                 .querySelector('#product-grid-Pagination')
//                 .replaceWith(newDocument.querySelector('#product-grid-Pagination'));

//             window.observer1.observe(document.querySelector('#product-grid-Pagination'));
//             isLoading = false;
//             updateImageUsingSlideShow();
//         };
//     }    
// });
document.addEventListener('DOMContentLoaded', () => {
    let productCardsLink = document.querySelectorAll('.searchtap-temp .product-grid product-card-link');
    productCardsLink.forEach(link=>{
        link.addEventListener('click',(e)=>{
            if (e.target.closest('.slideshow-control')) {
                return;
            }
            e.preventDefault();
            let url = link.querySelector('.product-card__link').getAttribute('href');
            if (url) {
                window.location.href = url;
            }
        })
    })
});

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelector(".mainplp_text");
    if(!elements) return;
    const OriginalUrl = new URL(window.location.href);

    let innerLinks = elements.querySelectorAll('.inner_imgtx a');
    innerLinks.forEach(link=>{
        link.addEventListener('click',(e)=>{
            e.preventDefault();
            e.stopImmediatePropagation();
            innerLinks.forEach(l => l.classList.remove('activetabbox'));
            link.classList.add('activetabbox');
            OriginalUrl.searchParams.delete("f.Occasion");
            const url = new URL(link.href);
            let lastValue = url.pathname.split('/').pop();
            lastValue = lastValue.toLowerCase();
            if(lastValue){
                OriginalUrl.searchParams.set("f.Occasion", lastValue);
            }
            let newUrl = OriginalUrl.toString().replace(/%20/g, "+").replace(/%2C/g, ",");
            history.pushState(newUrl, "filter", newUrl);
            window.applyTopFilter(newUrl);
        })
    });
});
